'use client';

interface KioskNavProps {
  onPrevious?: () => void;
  onNext?: () => void;
  nextDisabled?: boolean;
  nextLabel?: string;
  previousLabel?: string;
  showPrevious?: boolean;
  showNext?: boolean;
}

export default function KioskNav({
  onPrevious,
  onNext,
  nextDisabled = false,
  nextLabel = '다음',
  previousLabel = '이전',
  showPrevious = true,
  showNext = true,
}: KioskNavProps) {
  return (
    <div className="w-full flex justify-between px-8">
      {/* Previous Button */}
      {showPrevious && onPrevious ? (
        <button
          onClick={onPrevious}
          className="relative bg-green-500 hover:bg-green-600 text-white px-10 py-5 text-2xl font-semibold transition-colors"
          style={{
            clipPath: 'polygon(20% 0%, 100% 0%, 100% 100%, 20% 100%, 0% 50%)',
          }}
        >
          <div className="flex items-center justify-center">
            <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M15 19l-7-7 7-7" />
            </svg>
            <span className="mr-3">{previousLabel}</span>
          </div>
        </button>
      ) : (
        <div />
      )}

      {/* Next Button */}
      {showNext && onNext && (
        <button
          onClick={onNext}
          disabled={nextDisabled}
          className={`relative text-white px-10 py-5 text-2xl font-semibold transition-colors ${
            nextDisabled
              ? 'bg-orange-300 cursor-not-allowed'
              : 'bg-orange-500 hover:bg-orange-600'
          }`}
          style={{
            clipPath: 'polygon(0% 0%, 80% 0%, 100% 50%, 80% 100%, 0% 100%)',
          }}
        >
          <div className="flex items-center justify-center">
            <span className="ml-3">{nextLabel}</span>
            <svg className="w-6 h-6 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </button>
      )}
    </div>
  );
}
